import { ReactNode } from 'react'
import { InfoProvider } from './context/useInfo'
import { EnvironmentProvider } from './context/useEnv'

function App({ children, envProps = undefined }: { children: ReactNode, envProps?: any }) {
    return <EnvironmentProvider env={envProps} children={children} />
}

export default App